export default {"src":"/_next/static/media/americanbanker.5ec5dacc.svg","height":17,"width":111};